import React from "react";
import { Modal } from "components/modal/Modal";
import axios from "api";
import { Spinner } from "components/Spinner/Spinner";
import { ApiResponse } from "@avamae/formbuilder/dist/FormBuilder";
import warningIcon from "../../../assets/Icon_Notification_Warning.png";

type FailedToFlag = {
  id: number;
  reason: string;
};

type FlagResponse = {
  successfulUpdates: number[];
  failedUpdates: FailedToFlag[];
};

type ErrorFlagging = {
  hasError: boolean;
  failedToFlag: FailedToFlag[];
};

type Props<Data> = {
  open: boolean;
  close(): void;
  url: string;
  selectedData: (Data | undefined)[];
  selectedIds: React.ReactText[];
  idFromRowOption: React.ReactText | null;
  noun: string;
  pluralNoun?: string;
  renderListItem(data: Data): string | React.ReactNode;
  setToFavourite?: boolean;
  additionalDataIDs?: any;
  parentSelectedIdName?: string;
  parentSelectedId?: number;
};

function MarkAsFavouriteModal<Data>(props: Props<Data>) {
  const [submitting, setSubmitting] = React.useState(false);
  const [errorState, setErrorState] = React.useState<
    ErrorFlagging | undefined
  >();

  const {
    open,
    close,
    noun,
    selectedIds,
    selectedData,
    idFromRowOption,
    renderListItem,
    setToFavourite = true,
    additionalDataIDs,
    parentSelectedIdName,
    parentSelectedId,
  } = props;

  const pluralNoun = props.pluralNoun ?? noun + "s";

  const idsToFlag = idFromRowOption ? [idFromRowOption] : selectedIds;

  const handleMarkOrUnMark = () => {
    if (submitting) {
      return;
    }

    setSubmitting(true);
    let payload: any = {
      idsToFlag,
      bFavourite: setToFavourite,
    }; //versions - additionalDataIDs

    if (parentSelectedIdName && parentSelectedId) {
      payload[parentSelectedIdName] = parentSelectedId;
    }

    // console.log("payload: ", payload);
    axios
      .post<ApiResponse<any, FlagResponse>>(props.url, payload)
      .then(res => {
        if (res.status === 200) {
          if (
            res.data.status === "1" &&
            // res.data.details.failedToFlag.length === 0
            res.data.details.failedUpdates.length === 0
          ) {
            setErrorState(undefined);
            close();
          } else {
            // Failed deleting some users
            setErrorState({
              hasError: true,
              failedToFlag: res.data.details.failedUpdates,
            });
          }
        }
      })
      .catch(err => {
        // Generic error
        setErrorState({
          hasError: true,
          failedToFlag: [],
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Modal
      open={open}
      closeModal={close}
      title={setToFavourite ? "Mark as Favourite" : "Remove from favourites"}
      actionButton={
        <button className="Btn" onClick={handleMarkOrUnMark}>
          Apply
        </button>
      }
    >
      <div className="DeleteModal">
        {/* <h4>{setToFavourite ? "Mark as Favourite" : "Unmark as Favourite"}</h4> */}

        <p>
          {setToFavourite
            ? `Are you sure you want to make ${
                idsToFlag.length > 1 ? `these ${pluralNoun}` : `this ${noun}`
              } ${idsToFlag.length > 1 ? "favourites" : "a favourite"}
          ?`
            : `Are you sure you want to remove ${
                idsToFlag.length > 1
                  ? `these ${pluralNoun} from your favourites`
                  : `this ${noun} from your favourites`
              }`}
        </p>

        {/* <ul>
          {selectedData.map((user, i) => (
            <div key={i}>{user && renderListItem(user)}</div>
          ))}
        </ul> */}

        {errorState?.hasError && (
          <p>
            {errorState.failedToFlag.length > 0
              ? `Error flagging the following ${pluralNoun}:`
              : `Error flagging the following ${noun}:`}
            <ul>
              {errorState.failedToFlag.map((d, i) => (
                <li key={i}>
                  {d.id}: {d.reason}
                </li>
              ))}
            </ul>
          </p>
        )}
        {submitting && <Spinner positionAbsolute />}
      </div>
    </Modal>
  );
}

export default MarkAsFavouriteModal;
